module.exports = __webpack_public_path__ + "img/bos13.c75d56f9.webp";